import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards";

export default function DominicaJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="Dominica Jurisdiction"
                subtitle="Offshore Companies & Citizenship by Investment"
                description="Dominica is one of the most established Caribbean jurisdictions for offshore solutions. It is globally recognized for its Citizenship by Investment Program (CBI) and flexible International Business Company (IBC) structures, making it attractive for entrepreneurs, HNWIs, and global investors."
                badges={[
                    "Offshore Company Formation",
                    "Citizenship by Investment",
                    "Tax-Neutral Environment"
                ]}
                buttonText="Request a Dominica Jurisdiction Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/jurisdictions/dominica-jurisdiction.png')}
                imageAlt="Dominica Offshore Companies & Citizenship"
            />

            <section className='section'>
                <div className="container">


                    <WhySection
                        title='Why Choose Dominica?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Tax Neutrality",
                                        text: "No capital gains, inheritance, or wealth tax."
                                    },
                                    {
                                        title: "Fast Incorporation",
                                        text: "IBCs can be registered in 1–3 days."
                                    },
                                    {
                                        title: "Confidentiality",
                                        text: "Strong corporate privacy protections."
                                    },
                                    {
                                        title: "CBI Program",
                                        text: "One of the most affordable and respected citizenship programs."
                                    },
                                    {
                                        title: "Stable Legal System",
                                        text: "Based on English common law."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Company Formation in Dominica"
                        blocks={[
                            {
                                title: "International Business Company (IBC)",
                                items: [
                                    { text: "No corporate income tax on foreign-sourced income." },
                                    { text: "No minimum capital requirement." },
                                    { text: "1 shareholder and 1 director required (can be the same person)." },
                                    { text: "Confidential registers (not public)." },
                                    { text: "Commonly used for trading, consulting, asset holding, and IP protection." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Citizenship by Investment (CBI) in Dominica"
                        subtitle='Dominica’s CBI program is one of the world’s most reputable.'
                        blocks={[
                            {
                                title: "Investment Options",
                                items: [
                                    { text: "Donation – USD 100,000 to the Economic Diversification Fund." },
                                    { text: "Real Estate – USD 200,000+ in approved projects (villas, hotels, resorts)." }
                                ]
                            },
                            {
                                title: "Key Benefits",
                                items: [
                                    { text: "Visa-free travel to 140+ countries (including Schengen, UK, Singapore)." },
                                    { text: "Citizenship within 3–6 months." },
                                    { text: "Dual citizenship allowed." },
                                    { text: "Lifetime citizenship, passed on to future generations." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Financial Licenses in Dominica'
                        subtitle='Dominica also allows specialized offshore financial services licenses regulated by the Financial Services Unit (FSU), including:'
                        services={[
                            {
                                title: "Banking Licenses",
                            },
                            {
                                title: "Insurance Licenses",
                            },
                            {
                                title: "Mutual Fund Licenses",
                            },
                            {
                                title: "Trust Company Licenses",
                            }
                        ]}
                        end='These are less widely used than IBCs and CBI but are available for institutional investors.'
                    />

                    <FeatureCards
                        title='Advantages of Dominica Jurisdiction'
                        features={[
                            {
                                title: "Global Recognition",
                                text: "Respected CBI program."
                            },
                            {
                                title: "Flexible Corporate Structures",
                                text: "IBCs with no local taxation."
                            },
                            {
                                title: "Fast Processing",
                                text: "Companies in days, citizenship in months."
                            },
                            {
                                title: "Confidentiality & Asset Protection",
                                text: "Strong privacy and legal safeguards."
                            },
                            {
                                title: "Affordable Entry Point",
                                text: "CBI from USD 100,000."
                            }
                        ]}
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Looking for tax-neutral structures or a second passport?"
                        description="Offshore Advisory provides Dominica IBC incorporation, citizenship by investment assistance, and financial licensing support."
                        buttonText="Book a Dominica Consultation Today →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How long does it take to form an IBC in Dominica?",
        answer: "Typically 1–3 business days."
    },
    {
        question: "Can Dominica companies do business locally?",
        answer: "No, IBCs are meant for international operations only."
    },
    {
        question: "What is the minimum investment for citizenship?",
        answer: "USD 100,000 donation or USD 200,000 in real estate."
    },
    {
        question: "Is Dominica a tax haven?",
        answer: "It is considered tax-neutral, not blacklisted by the EU when structured properly."
    },
    {
        question: "Can Dominica citizenship be inherited?",
        answer: "Yes, it passes to future generations."
    }
];

